export default {
    book: 'Prenota {product}',
    age_limit: 'Solo oltre i {age} anni',
    upgrade_product: 'Aggiorna prodotto',
    choose_product: 'Scegli {product}',
    days: '{count} giorno | {count} giorni',
    login_register: "Login / Registrazione",
    keyless_benefits: {
        label: 'Subito in auto {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Assicurazione completa',
            zero_excess: 'Zero Excess',
            phone_as_a_key: 'Telefono come chiave',
            straight_to_car: 'Nessuna attesa',
            no_queues: 'Nessuna fila',
            online_id_check: 'Controllo documento di identità online',
            self_checkout: 'Checkout indipendente',
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/it/quotes/vehicle_card.js